import NyafazPortalFlowLayout from "../enterprise-portal/NyafazPortalFlowLayout";

export default NyafazPortalFlowLayout;
